export const CALCULATOR_ENV_VALUES = ["agpss", "website", "dealer"] as const;
export type CalculatorEnv = (typeof CALCULATOR_ENV_VALUES)[number];

export const usesDefaultFrameContract = (calculatorEnv: string, slug: string, accesscode: string) => {
  if (calculatorEnv === "website" || calculatorEnv === "dealer") {
    return true;
  }
  return slug === "" && accesscode === "";
};
